import React, { FC } from 'react'
import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import { slugs } from '@/constants/slugs'
import TicketPackSection from '@/views/PreSales/PreSalesGiveawayView/components/TicketPack/TicketPackSection'
import { TabButton } from './TabButton'
import { TabPanels } from './TabPanels'
import { useGiveawayTabs } from './hooks/useGiveawayTabs'

export const GiveawayTabs: FC = () => {
  const {
    tabs,
    isSingleTab,
    activeTab,
    selectedIndex,
    handleTabChange,
    handleTabClick,
    isActive,
    tabsContainerRef,
    desktopTicketContainerRef,
    shouldShowTicketSection,
    refs,
    theatricalSlug,
  } = useGiveawayTabs()

  return (
    <div
      ref={tabsContainerRef}
      className={classNames(
        'mx-auto flex w-full bg-giveaway-background-subtlest-light',
        theatricalSlug === slugs.sketch &&
          "bg-[url('https://images.angelstudios.com/image/upload/v1750981652/sketch/bg-sml.webp')] bg-repeat",
      )}
    >
      <div
        className={classNames(
          'relative min-h-screen w-full pb-10 lg:pb-0',
          isActive ? 'max-w-[960px] ml-auto' : 'max-w-[1440px] mx-auto',
        )}
      >
        <Tab.Group selectedIndex={isSingleTab ? 0 : selectedIndex} onChange={handleTabChange}>
          <Tab.List
            className={classNames(
              'sticky top-0 z-30 flex justify-center gap-8 border-b-2 border-giveaway-primary-accent-dark bg-giveaway-background-subtlest-light  pb-4 pt-6',
              theatricalSlug === slugs.senior && ' !bg-giveaway-primary-subtle',
            )}
          >
            {tabs.map((tab) => (
              <TabButton
                key={tab.title}
                tab={tab}
                isSingleTab={isSingleTab}
                activeTab={activeTab}
                isActive={isActive}
                onTabClick={handleTabClick}
              />
            ))}
          </Tab.List>
          <TabPanels isSingleTab={isSingleTab} tabs={tabs} refs={refs} />
        </Tab.Group>
      </div>

      {shouldShowTicketSection && (
        <TicketPackSection
          ref={desktopTicketContainerRef}
          className="hidden w-full max-w-[480px] lg:mr-auto lg:block"
        />
      )}
    </div>
  )
}
